import {STATUSES} from "../../components/statuses";
import axios from '@/config/axios';
import router from '@/router/index';
import each from 'lodash/each';
import dotObject from 'dot-object';
import {getField, updateField} from "vuex-map-fields";
import {GET_PROFILE, SET_STATE} from "../mutations";
import {TOGGLE_LOADER, GET_CREDIT_INFO} from "@/storage/mutations";

const credit = {
    namespaced: true,
    state: {
        creditID: null,
        bankID: '',
        IBAN: '',
        IBANExternalError: {
            haveError: false,
            errorText: ''
        },
        IBANExternalStatus: STATUSES.EMPTY,
        creditStatus: '',
    },
    mutations: {
        updateField,
        updateState(state, payload) {
            state.creditID = payload.id;
            state.creditStatus = payload.status;
        }
    },
    actions: {
        GET_CREDIT_INFO(){
            let _this  = this;
            axios.get('/json/credit/last').then(
                (response) => {
                    if( response.data.code === 0){
                        if(response.data.data){
                            _this.commit('credit/updateState', response.data.data);
                        }
                    }
                },
                (response) => {

                },
            )
        }
    },
    getters: {
        getField
    }
};

export default credit;
